import { useQuery } from '@tanstack/react-query';
import { apiGetProjectMembers } from '../api/projectMembers.api';

export function useProjectMembers(projectId: string, enabled = true) {
    return useQuery({
        queryKey: ['projectMembers', projectId],
        queryFn: () => apiGetProjectMembers(projectId),
        enabled,
    });
}
